var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/status/components/card.tsx";
import "core-js/modules/es.array.includes.js";
import classnames from 'classnames';
import { List as ImmutableList } from 'immutable';
import React, { useState } from 'react';
import Blurhash from 'soapbox/components/blurhash';
import Icon from 'soapbox/components/icon';
import { HStack, Stack, Text } from 'soapbox/components/ui';
import { normalizeAttachment } from 'soapbox/normalizers';
const trim = (text, len) => {
  const cut = text.indexOf(' ', len);
  if (cut === -1) {
    return text;
  }
  return text.substring(0, cut) + (text.length > len ? '…' : '');
};
const domParser = new DOMParser();
const addAutoPlay = html => {
  const document = domParser.parseFromString(html, 'text/html').documentElement;
  const iframe = document.querySelector('iframe');
  if (iframe) {
    if (iframe.src.includes('?')) {
      iframe.src += '&';
    } else {
      iframe.src += '?';
    }
    iframe.src += 'autoplay=1&auto_play=1';
    iframe.allow = 'autoplay';

    // DOM parser creates html/body elements around original HTML fragment,
    // so we need to get innerHTML out of the body and not the entire document
    return document.querySelector('body').innerHTML;
  }
  return html;
};
const CardLink = ({
  className,
  card,
  description
}) => {
  return /*#__PURE__*/React.createElement("a", {
    href: card.url,
    className: className,
    target: "_blank",
    rel: "noopener",
    onClick: e => e.stopPropagation(),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 5
    }
  }, card.image ? /*#__PURE__*/React.createElement("div", {
    className: classnames('status-card__image', 'w-full rounded-l md:w-auto md:h-auto flex-none md:flex-auto', 'h-[200px]'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Blurhash, {
    className: "absolute w-full h-full inset-0 -z-10",
    hash: card.blurhash,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundImage: `url(${card.image})`
    },
    className: "status-card__image-image",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 13
    }
  })) : /*#__PURE__*/React.createElement("div", {
    className: "status-card__image status-card__image--empty",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/file-text.svg'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 13
    }
  })), description);
};
const CardPhoto = ({
  className,
  card,
  description,
  onOpenMedia,
  trimmedTitle
}) => {
  const handlePhotoClick = e => {
    e.stopPropagation();
    const attachment = normalizeAttachment({
      type: 'image',
      url: card.embed_url,
      description: trimmedTitle,
      meta: {
        original: {
          width: card.width,
          height: card.height
        }
      }
    });
    onOpenMedia(ImmutableList([attachment]), 0);
  };
  return /*#__PURE__*/React.createElement("a", {
    href: card.url,
    className: className,
    target: "_blank",
    rel: "noopener",
    onClick: handlePhotoClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 121,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames('status-card__image', 'w-full rounded-l md:w-auto md:h-auto flex-none md:flex-auto', 'h-[200px]'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 128,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Blurhash, {
    className: "absolute w-full h-full inset-0 -z-10",
    hash: card.blurhash,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 134,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundImage: `url(${card.image})`
    },
    className: "status-card__image-image",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 138,
      columnNumber: 9
    }
  })), description);
};
const CardVideo = ({
  className,
  card,
  description
}) => {
  const [embedded, setEmbedded] = useState(false);
  const [width, setWidth] = useState(0);
  const getRatio = card => {
    const ratio = card.width / card.height || 16 / 9;

    // Constrain to a sane limit
    // https://en.wikipedia.org/wiki/Aspect_ratio_(image)
    return Math.min(Math.max(9 / 16, ratio), 4);
  };
  const ratio = getRatio(card);
  const height = width / ratio;
  const handleEmbedClick = e => {
    e.stopPropagation();
    setEmbedded(true);
  };
  const setRef = c => {
    if (c) {
      setWidth(c.offsetWidth);
    }
  };
  return /*#__PURE__*/React.createElement("a", {
    href: card.url,
    className: className,
    target: "_blank",
    rel: "noopener",
    onClick: e => e.stopPropagation(),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 182,
      columnNumber: 5
    }
  }, embedded ? /*#__PURE__*/React.createElement("div", {
    ref: setRef,
    className: "status-card__image status-card-video",
    dangerouslySetInnerHTML: {
      __html: addAutoPlay(card.html)
    },
    style: {
      height
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 191,
      columnNumber: 11
    }
  }) : /*#__PURE__*/React.createElement("div", {
    className: "status-card__image",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 198,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Blurhash, {
    className: "absolute w-full h-full inset-0 -z-10",
    hash: card.blurhash,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 199,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundImage: `url(${card.image})`
    },
    className: "status-card__image-image",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 203,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 flex items-center justify-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 210,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-white shadow-md rounded-md p-2 flex items-center justify-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 211,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    space: 3,
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 212,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: handleEmbedClick,
    className: "appearance-none text-gray-400 hover:text-gray-600",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 213,
      columnNumber: 19
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/player-play.svg'),
    className: "w-5 h-5 text-inherit",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 214,
      columnNumber: 21
    }
  })))))), description);
};
const Card = ({
  card,
  onOpenMedia
}) => {
  const trimmedTitle = trim(card.title, 120);
  const trimmedDescription = trim(card.description, 200);
  const interactive = card.type !== 'link';
  const className = classnames('status-card', {
    interactive
  }, `status-card--${card.type}`);
  const title = interactive ? /*#__PURE__*/React.createElement("a", {
    onClick: e => e.stopPropagation(),
    href: card.url,
    title: trimmedTitle,
    rel: "noopener",
    target: "_blank",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 246,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("span", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 253,
      columnNumber: 7
    }
  }, trimmedTitle)) : /*#__PURE__*/React.createElement("span", {
    title: trimmedTitle,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 256,
      columnNumber: 5
    }
  }, trimmedTitle);
  const description = /*#__PURE__*/React.createElement(Stack, {
    space: 2,
    className: "flex-1 overflow-hidden p-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 260,
      columnNumber: 5
    }
  }, trimmedTitle && /*#__PURE__*/React.createElement(Text, {
    weight: "bold",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 262,
      columnNumber: 9
    }
  }, title), trimmedDescription && /*#__PURE__*/React.createElement(Text, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 265,
      columnNumber: 9
    }
  }, trimmedDescription), /*#__PURE__*/React.createElement(HStack, {
    space: 1,
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 267,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    theme: "muted",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 268,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/link.svg'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 269,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    theme: "muted",
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 271,
      columnNumber: 9
    }
  }, card.provider_name)));
  if (card.type === 'video') {
    return /*#__PURE__*/React.createElement(CardVideo, {
      card: card,
      className: className,
      description: description,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 279,
        columnNumber: 12
      }
    });
  } else if (card.type === 'photo') {
    return /*#__PURE__*/React.createElement(CardPhoto, {
      trimmedTitle: trimmedTitle,
      onOpenMedia: onOpenMedia,
      card: card,
      className: className,
      description: description,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 281,
        columnNumber: 12
      }
    });
  }
  return /*#__PURE__*/React.createElement(CardLink, {
    card: card,
    className: className,
    description: description,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 283,
      columnNumber: 10
    }
  });
};
export default Card;